import React, { ReactNode } from 'react'
import { Button, Spinner } from '@dw/helix'
import { css } from '@emotion/core'

const spinnerStyles = css`
  margin: -2px 0;
`

export type Size = 'medium' | 'small'
export type Theme = 'primary' | 'secondary' | 'secondary-white' | 'tertiary'

interface ButtonWithLoadingProps {
  loading: boolean
  children?: ReactNode
  theme?: Theme
  size?: Size
  className?: string
  as?: any
  preventDisabledStyles?: boolean
  [key: string]: any
}

const ButtonWithLoading: React.FunctionComponent<ButtonWithLoadingProps> = props => {
  return (
    <Button {...props}>{props.loading ? <Spinner css={spinnerStyles} color="currentColor" /> : props.children}</Button>
  )
}

export default ButtonWithLoading
